import { useQuery } from '@tanstack/react-query'
import { releaseService } from '../services/apiService'

export default function ReleasesPage() {
  const { data: releases, isLoading } = useQuery({
    queryKey: ['releases'],
    queryFn: releaseService.getAll,
  })

  if (isLoading) return <div>Loading releases...</div>

  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">Latest Releases</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {releases?.map((release) => (
          <div key={release.id} className="border rounded-lg p-4">
            {release.coverArtUrl && (
              release.streamingLinks?.bandcamp ? (
                <a
                  href={release.streamingLinks.bandcamp}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block mb-4 hover:opacity-80 transition-opacity"
                >
                  <img
                    src={release.coverArtUrl}
                    alt={release.title}
                    className="w-full aspect-square object-cover rounded"
                  />
                </a>
              ) : (
                <img
                  src={release.coverArtUrl}
                  alt={release.title}
                  className="w-full aspect-square object-cover rounded mb-4"
                />
              )
            )}
            {release.streamingLinks?.bandcamp ? (
              <a
                href={release.streamingLinks.bandcamp}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline"
              >
                <h2 className="text-lg font-bold mb-1">{release.title}</h2>
              </a>
            ) : (
              <h2 className="text-lg font-bold mb-1">{release.title}</h2>
            )}
            <p className="text-sm text-gray-600 mb-2">{release.artistName}</p>
            <p className="text-xs text-gray-500">
              {new Date(release.releaseDate).toLocaleDateString()}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}
